import React from 'react';

import { DatasetInspectorMessageContainer } from '../dataset-inspector-message/DatasetInspectorMessage.container';

import Box from 'Common/Box/Box';
import { EntityBrowserList } from './DatasetInspectorBrowserList';

import type { Dataset } from '../../../types/dataset.types';
import type { Entity } from '../../../types/entities.types';
import type { DatasetInspectorFilters } from '../../../types/enums';

import './DatasetInspectorBrowserStyle.css';

export const DatasetInspectorBrowser: React.FC<{
  dataset: Dataset;
  filter?: DatasetInspectorFilters;
  pipeId: string;
  offsetDifference: number;
  onEntityRef: (el: HTMLDivElement, entity: Entity, idx: number) => void;
  onScroll: () => void;
  onSetRef: (el: HTMLDivElement) => void;
  showingSearchResults: boolean;
  stopSearch: () => void;
  displayRepostAll?: boolean;
  repostDeadEntities: () => void;
  populate: () => void;
}> = (props) => (
  <div className="dataset-inspector-browser">
    {/* @ts-ignore */}
    <Box>
      <Box.Header>
        <DatasetInspectorMessageContainer
          dataset={props.dataset}
          filter={props.filter}
          stopSearch={props.stopSearch}
          pipeId={props.pipeId}
          populate={props.populate}
          offsetDifference={props.offsetDifference}
        />
      </Box.Header>
      {/* @ts-ignore */}
      <Box.Content
        white
        style={{ maxHeight: props.displayRepostAll ? 'calc(100% - 90px)' : '100%' }}
      >
        <EntityBrowserList
          onScroll={props.onScroll}
          onSetRef={props.onSetRef}
          onEntityRef={props.onEntityRef}
          showingSearchResults={props.showingSearchResults}
          displayRepostAll={props.displayRepostAll}
          repostDeadEntities={props.repostDeadEntities}
          filter={props.filter}
        />
      </Box.Content>
    </Box>
  </div>
);
